export function copyrightDisplayText(isBoiWebsite: Boolean) {
	const currentYear = new Date().getFullYear();
	return isBoiWebsite ? `© ${currentYear} Nevo` : `© Nevo ${currentYear}`;
}
